var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BInputGroup, BFormInput } from 'bootstrap-vue';
let MountCustomBorders = class MountCustomBorders extends Vue {
    get widthBorderTotal() {
        return this.externalSize.width - this.apertureSize.width;
    }
    get lengthBorderTotal() {
        return this.externalSize.length - this.apertureSize.length;
    }
    get validity() {
        return {
            top: this.selectedBorders.top >= 10,
            left: this.selectedBorders.left >= 10,
            right: this.selectedBorders.right >= 10,
            bottom: this.selectedBorders.bottom >= 10,
        };
    }
    onWidthChange(side) {
        // Set the opposing
        let borders = this.selectedBorders;
        borders[side == 'left' ? 'right' : 'left'] = this.widthBorderTotal - borders[side];
        this.$emit('border-change', borders);
    }
    onLengthChange(side) {
        // Set the opposing
        let borders = this.selectedBorders;
        borders[side == 'top' ? 'bottom' : 'top'] = this.lengthBorderTotal - borders[side];
        this.$emit('border-change', borders);
    }
};
__decorate([
    Prop(Object)
], MountCustomBorders.prototype, "externalSize", void 0);
__decorate([
    Prop(Object)
], MountCustomBorders.prototype, "apertureSize", void 0);
__decorate([
    Prop(String)
], MountCustomBorders.prototype, "unit", void 0);
__decorate([
    ModelSync('borders', 'border-change', { type: Object })
], MountCustomBorders.prototype, "selectedBorders", void 0);
MountCustomBorders = __decorate([
    Component({
        components: {
            BRow, BCol, BFormGroup, BInputGroup, BFormInput
        }
    })
], MountCustomBorders);
export default MountCustomBorders;
